import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import { getInfoCertificadoById, getToken, registerCertificadoOpen, updateCertificadoById } from "../services/api";
import "../styles/form.css";
import { useParams } from "react-router-dom";

const CertificadoCita = () => {
    const [certificadoInfo, setCertificadoInfo] = useState(null);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [zoomLevel, setZoomLevel] = useState(1);
    const [isWhatsAppBrowser, setIsWhatsAppBrowser] = useState(false);
    const [yaVisualizado, setYaVisualizado] = useState(false);
    const [certificadoBloqueado, setCertificadoBloqueado] = useState(false);
    const { id } = useParams();

    // Detectar si el usuario está en Android (donde WhatsApp tiene problemas con PDFs)
    useEffect(() => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        
        // Detectar Android
        const isAndroid = /Android/i.test(userAgent);
        
        // Detectar si es un navegador móvil
        const isMobile = /Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
        
        // Detectar navegadores in-app conocidos
        const isInAppBrowser = 
            /WhatsApp/i.test(userAgent) ||
            /FBAN|FBAV|FB_IAB|FB4A/i.test(userAgent) ||
            /Instagram/i.test(userAgent) ||
            /Messenger/i.test(userAgent) ||
            /wv\)/i.test(userAgent) || // WebView
            userAgent.includes('[wv]');
        
        // Mostrar alerta si es Android Y (es navegador in-app O es móvil)
        // Esto cubre WhatsApp en Android que tiene problemas con PDFs
        const shouldShowWarning = isAndroid && (isInAppBrowser || isMobile);
        
        setIsWhatsAppBrowser(shouldShowWarning);
        
        if (shouldShowWarning) {
            // Forzar scroll al inicio para que vean la alerta
            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 100);
        }
    }, []);

    const adjustZoom = (delta) => {
        setZoomLevel(prev => {
            const newZoom = prev + delta;
            return Math.max(0.5, Math.min(3, newZoom)); // Limitar entre 50% y 300%
        });
    };

    const copyUrlToClipboard = () => {
        const currentUrl = window.location.href;
        
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(currentUrl)
                .then(() => {
                    alert('✅ ¡URL copiada!\n\nAhora:\n1. Abre Chrome\n2. Pega el enlace en la barra de direcciones\n3. Presiona Enter');
                })
                .catch((err) => {
                    console.error('Error al copiar:', err);
                    fallbackCopyUrl(currentUrl);
                });
        } else {
            fallbackCopyUrl(currentUrl);
        }
    };

    const fallbackCopyUrl = (text) => {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        document.body.appendChild(textArea);
        textArea.select();
        
        try {
            document.execCommand('copy');
            alert('✅ ¡URL copiada!\n\nAhora:\n1. Abre Chrome\n2. Pega el enlace en la barra de direcciones\n3. Presiona Enter');
        } catch (err) {
            console.error('Error al copiar:', err);
            alert('URL del certificado:\n\n' + text + '\n\nCopia este enlace y ábrelo en Chrome');
        }
        
        document.body.removeChild(textArea);
    };

    const handleDownload = async () => {
        try {
            if (!pdfUrl) {
                console.error('No hay URL del PDF disponible');
                return;
            }

            const link = document.createElement('a');
            link.href = pdfUrl;
            link.download = `${certificadoInfo?.name || 'certificado'}.pdf`;
            link.target = '_blank';
            
            document.body.appendChild(link);
            link.click();
            
            document.body.removeChild(link);
            
            console.log('Descarga iniciada:', certificadoInfo?.name);
        } catch (error) {
            console.error('Error al descargar el archivo:', error);
            window.open(pdfUrl, '_blank');
        }
    };


    useEffect(() => {
        const fetchCertificado = async () => {
            try {
                setLoading(true);
                const token = await getToken("syso.santiago", "Santiago1103");
                if (token) {
                    sessionStorage.setItem("token", token);
                    
                    // Obtener información del certificado
                    const data = await getInfoCertificadoById(id);
                    if (data?.length > 0) {
                        const certificado = data[0];
                        const estaVisualizado = certificado[3]; // Visualizado_ está en el índice 3
                        const fechaPublicado = certificado[4]; // Fecha_Publicado está en el índice 4
                        
                        setCertificadoInfo({
                            id: certificado[0],
                            name: certificado[1],
                            pdfUrl: certificado[2],
                            visualizado: estaVisualizado,
                            fechaPublicado: fechaPublicado
                        });
                        
                        // Verificar si ya fue visualizado (bloqueado)
                        if (estaVisualizado) {
                            setYaVisualizado(true);
                            console.log("Este certificado ya fue visualizado/bloqueado anteriormente");
                        } else {
                            // Calcular días transcurridos desde la fecha de publicación
                            const fechaPublicacion = new Date(fechaPublicado);
                            const fechaActual = new Date();
                            const diasTranscurridos = Math.floor((fechaActual - fechaPublicacion) / (1000 * 60 * 60 * 24));
                            
                            console.log(`Días transcurridos desde la publicación: ${diasTranscurridos}`);
                            
                            if (diasTranscurridos > 7) {
                                // Si han pasado más de 7 días, ejecutar el bloqueo
                                const openDate = new Date().toISOString();
                                await updateCertificadoById(id, openDate);
                                console.log("Certificado bloqueado: han pasado más de 7 días. Bloqueo ejecutado:", openDate);
                                
                                // Mostrar mensaje de certificado bloqueado
                                setCertificadoBloqueado(true);
                            } else {
                                // Menos de 7 días: mostrar el PDF sin bloquear
                                setPdfUrl(certificado[2]);
                                console.log(`Certificado disponible. Faltan ${7 - diasTranscurridos} días para el bloqueo automático.`);
                            }
                        }
                    } else {
                        setError("No se encontró información del certificado");
                    }
                } else {
                    setError("Error al obtener el token de autenticación");
                }
            } catch (err) {
                console.error("Error al cargar el certificado:", err);
                setError("Error al cargar el certificado");
            } finally {
                setLoading(false);
            }
        };
        
        fetchCertificado();
    }, []);

    if (loading) {
        return (
            <Layout>
                <div className="certificado-container">
                    <h1 className="form-title">Cargando certificado...</h1>
                    <div className="loading-spinner">
                        <div className="spinner"></div>
                    </div>
                </div>
            </Layout>
        );
    }

    if (error) {
        return (
            <Layout>
                <div className="certificado-container">
                    <h1 className="form-title">Error</h1>
                    <div className="error-message">
                        <p>{error}</p>
                        <button 
                            className="retry-button" 
                            onClick={() => window.location.reload()}
                        >
                            Reintentar
                        </button>
                    </div>
                </div>
            </Layout>
        );
    }

    // Mostrar mensaje si el certificado está bloqueado por tiempo
    if (certificadoBloqueado) {
        return (
            <Layout>
                <div className="certificado-container">
                    <div className="visualizado-message">
                        <div className="visualizado-icon">🔒</div>
                        <h1 className="form-title">Certificado Bloqueado</h1>
                        <div className="visualizado-content">
                            <p>
                                Este certificado <strong>"{certificadoInfo?.name}"</strong> ha expirado.
                            </p>
                            <p>
                                Han pasado más de 7 días desde su fecha de publicación, por lo que ya no está disponible para visualización.
                            </p>
                            <p>
                                Si necesitas acceder a este certificado, por favor contacta con el administrador.
                            </p>
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }

    // Mostrar mensaje si el certificado ya fue visualizado
    if (yaVisualizado) {
        return (
            <Layout>
                <div className="certificado-container">
                    <div className="visualizado-message">
                        <div className="visualizado-icon">⚠️</div>
                        <h1 className="form-title">Certificado Ya Visualizado</h1>
                        <div className="visualizado-content">
                            <p>
                                Este certificado <strong>"{certificadoInfo?.name}"</strong> ya fue visualizado anteriormente.
                            </p>
                            <p>
                                Por razones de seguridad, el contenido del certificado solo puede ser visualizado una vez.
                            </p>
                            <p>
                                Si necesitas acceder nuevamente a este certificado, por favor contacta con el administrador.
                            </p>
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }

    return (
        <Layout>
            <div className="certificado-container">
                {/* Alerta para navegadores in-app en Android */}
                {isWhatsAppBrowser && (
                    <div className="browser-warning">
                        <div className="warning-icon">⚠️</div>
                        <h2 className="warning-title">¡Importante! Lee esto primero</h2>
                        <p className="warning-message">
                            Si el certificado no se ve correctamente o la página se congela, 
                            necesitas abrirlo en tu navegador Chrome o Firefox.
                        </p>
                        <div className="warning-instructions">
                            <p><strong>🔴 OPCIÓN 1 (Más Fácil) - Usar el menú:</strong></p>
                            <ol>
                                <li>Toca los <strong>tres puntos (⋮)</strong> arriba a la derecha de la pantalla</li>
                                <li>Busca y toca <strong>"Abrir en el navegador"</strong>, <strong>"Abrir en Chrome"</strong> o similar</li>
                                <li>¡Listo! El certificado se abrirá en Chrome</li>
                            </ol>
                            
                            <p style={{marginTop: '20px', borderTop: '1px solid #ddd', paddingTop: '15px'}}><strong>⭐ OPCIÓN 2 - Copiar y pegar:</strong></p>
                            <ol>
                                <li>Presiona el botón amarillo de abajo ⬇️</li>
                                <li>Se copiará el enlace automáticamente</li>
                                <li>Abre la app <strong>Chrome</strong></li>
                                <li>Mantén presionado en la barra de direcciones y selecciona "Pegar"</li>
                                <li>Presiona Enter</li>
                            </ol>
                        </div>
                        <button 
                            className="copy-url-button"
                            onClick={copyUrlToClipboard}
                        >
                            📋 Copiar Enlace
                        </button>
                        <p className="warning-footer">
                            💡 <strong>Recomendamos la OPCIÓN 1</strong> (usar el menú de tres puntos) porque es más rápida
                        </p>
                    </div>
                )}
                
                <h1 className="form-title">
                    {certificadoInfo?.name || "Certificado"}
                </h1>
                
                {pdfUrl ? (
                    <div className="pdf-viewer-container">
                        <div className="pdf-controls">
                            <button 
                                className="zoom-button zoom-out"
                                onClick={() => adjustZoom(-0.1)}
                                title="Alejar"
                            >
                                −
                            </button>
                            <span className="zoom-level">{Math.round(zoomLevel * 100)}%</span>
                            <button 
                                className="zoom-button zoom-in"
                                onClick={() => adjustZoom(0.1)}
                                title="Acercar"
                            >
                                +
                            </button>
                            <button 
                                className="reset-zoom-button"
                                onClick={() => setZoomLevel(1)}
                                title="Tamaño original"
                            >
                                Reset
                            </button>
                        </div>
                        <div className="pdf-wrapper">
                            <iframe
                                src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=1&zoom=${Math.round(zoomLevel * 100)}`}
                                width="100%"
                                height="100%"
                                title="Certificado PDF"
                                className="pdf-iframe"
                                style={{ 
                                    transform: `scale(${zoomLevel})`,
                                    transformOrigin: 'top left',
                                    width: `${100 / zoomLevel}%`,
                                    height: `${100 / zoomLevel}%`
                                }}
                            />
                        </div>
                        <div className="pdf-actions">
                            <button 
                                onClick={handleDownload}
                                className="download-button"
                                title="Descargar certificado"
                            >
                                💾 Descargar PDF
                            </button>
                            <a 
                                href={pdfUrl} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="open-button"
                            >
                                📄 Abrir en nueva ventana
                            </a>
                        </div>
                    </div>
                ) : (
                    <div className="no-pdf-message">
                        <p>No se encontró el archivo PDF del certificado.</p>
                    </div>
                )}
            </div>
        </Layout>
    );
};

export default CertificadoCita;